import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {faQuestionCircle} from '@fortawesome/free-regular-svg-icons';

@Component({
    selector: 'di-help',
    template: `
        <a class="nav-link" [ngStyle]="{'margin-left': getMarginLeft() + 'px'}" (click)="help()">
            <span>Help</span>
            <fa-icon [icon]="faQuestionCircle" class="ml-4" style="align-self: center"></fa-icon>
        </a>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DiHelpComponent implements OnInit {
    @Input() link: string | null;
    @Input() marginLeft?: number; // optional

    faQuestionCircle = faQuestionCircle;

    constructor() {}

    ngOnInit(): void {}

    help(): void {
        window.open(this.link);
    }

    getMarginLeft(): number {
        // If marginLeft is provided and is a number, use it, otherwise default to 15
        return this.marginLeft !== undefined ? this.marginLeft : 15;
    }
}
